module.exports = __webpack_public_path__ + "img/support-forum.97968f99.svg";